<template>
  <v-row>
    <v-col>
      <p class="mb-2">
        <span class="display-1">Required Equipment</span><span class="subtitle-1">(Please complete brand information and notes about your equipment)</span>
      </p>
      <EquipmentTable @reloadtable="loadTable" :site_equipment="site_equipment" :loading="loading"/>
      <br>
      <p v-if="additional_equipment && additional_equipment.length > 0" class="mb-2">
        <span class="display-1" v-if="!loading">Miscellaneous Equipment</span>
      </p>
      <AdditionalEquipmentTable :equipment="additional_equipment" :loading="loading"/>
    </v-col>
  </v-row>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import EquipmentTable from './EquipmentList/EquipmentTable'
import AdditionalEquipmentTable from './EquipmentList/AdditionalEquipmentTable'

export default {
  components: {
    EquipmentTable,
    AdditionalEquipmentTable
  },
  data() {
    return {
      additional_equipment: null,
      site_equipment: null,
      loading: true
    }
  },
  methods: {
    loadTable() {
      const vm = this
      const id = vm.$store.state.assignment
      const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

      vm.loading = true
      getOpusApi({
        table: `vendor_assignments/${id}`,
        params: {
          include: 'performance_site_equipment,event_additional_equipment,performance_additional_equipment'
        }
      }).then(function(response) {
        // console.log(response.data.result)
        vm.site_equipment = response.data.result.performance_site_equipment
        if(response.data.result.performance_additional_equipment == undefined && response.data.result.event_additional_equipment == undefined) {
          vm.additional_equipment = null
        }
        else {
          const perf = response.data.result.performance_additional_equipment
          vm.additional_equipment = perf != undefined && perf.length > 0 ? perf : response.data.result.event_additional_equipment
        }
        vm.loading = false
      })
    }
  },
  mounted() {
    this.loadTable()
  }
}
</script>